import React from 'react';
import { FiAlertCircle } from 'react-icons/fi';

interface FormFieldProps {
  label: string;
  required?: boolean;
  error?: string;
  hint?: string;
  children: React.ReactNode;
  style?: React.CSSProperties;
}

const FormField: React.FC<FormFieldProps> = ({
  label,
  required,
  error,
  hint,
  children,
  style,
}) => (
  <div className={`form-group ${error ? 'has-error' : ''}`} style={style}>
    <label>
      {label}{required && <span style={{ color: '#ef4444', marginLeft: '2px' }}>*</span>}
    </label>
    {children}
    {error && (
      <div className="field-error">
        <FiAlertCircle size={12} /> {error}
      </div>
    )}
    {!error && hint && (
      <div className="form-hint">{hint}</div>
    )}
  </div>
);

export default FormField;
